import { Badge, Card, Col, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
  color,
  GUTTER_VARIATIONS,
  NA_PLACEHOLDER_TEXT,
} from '../../../../common/constants';
import { ProfileCardProps } from '../graphql/clients.type';

dayjs.extend(relativeTime);
const { Text } = Typography;

const ProfileCard = ({ title, data }: ProfileCardProps) => {
  return (
    <Card className="pl-8 pr-8">
      <div className="d-flex flex-vertical gap-16">
        <Text className="heading">{title}</Text>
        <Row gutter={[GUTTER_VARIATIONS, GUTTER_VARIATIONS]} className="mt-16">
          <Col xs={8} xl={8} className="d-grid">
            <Text className="title">GSTIN</Text>
            <span className="value color-blue">
              {data?.gstNumber || NA_PLACEHOLDER_TEXT}
            </span>
          </Col>
          <Col xs={8} xl={8} className="d-grid">
            <Text className="title">Trade Name</Text>
            <Text className="value">
              {data?.tradeName || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} xl={8} className="d-grid">
            <Text className="title">Legal Name of Business</Text>
            <Text className="value">
              {data?.businessName || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
        </Row>
        <Row gutter={[GUTTER_VARIATIONS, GUTTER_VARIATIONS]} className="mt-16">
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Centre Jurisdiction</Text>
            <Text className="value">
              {data?.centerJurisdiction || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">State Jurisdiction</Text>
            <Text className="value">
              {data?.stateJurisdiction || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Date of Registration</Text>
            <Text className="value">
              {data?.registrationDate || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
        </Row>
        <Row gutter={[GUTTER_VARIATIONS, GUTTER_VARIATIONS]} className="mt-16">
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Constitution of Business</Text>
            <Text className="value">
              {data?.constitutionOfBusiness || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Taxpayer Type</Text>
            <Text className="value">
              {data?.taxPayerType || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Compliance Ratings</Text>
            <Text className="value">
              {data?.complianceRating || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
        </Row>
        <Row gutter={[GUTTER_VARIATIONS, GUTTER_VARIATIONS]} className="mt-16">
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">Field Visit Conducted</Text>
            <Text className="value">
              {data?.fieldVisitConducted || NA_PLACEHOLDER_TEXT}
            </Text>
          </Col>
          <Col xs={8} lg={8} xl={8} className="d-grid">
            <Text className="title">GSTIN/UIN Status</Text>
            <Text className="value">
              <Badge
                status="default"
                color={color}
                text={data?.gstStatus || NA_PLACEHOLDER_TEXT}
              />
            </Text>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default ProfileCard;
